"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assert = void 0;
const assert = (condition, errMsg) => {
    if (!condition) {
        const errText = `Assertion failed` + (errMsg ? `: ${errMsg}` : "");
        throw new Error(errText);
    }
};
exports.assert = assert;
//# sourceMappingURL=errors.js.map